import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { snackbarInfoDefault } from '../../../../../../snackbarsStack';
import { getMessages } from '../../../../../../../../store/constants';

const SNACKBAR_ID = 'SNACKBAR_ID_DATES_DISABLED';

export const onShowSnackbar = (): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(snackbarInfoDefault({
            id: SNACKBAR_ID,
            text: getMessages().getText('kanban.dates.snackbar')
        }));
    }
}
